import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ObjetMaquette } from '../objet-maquette.model';

@Injectable({
    providedIn: 'root'
})
export class CommandEvents {
    public objetMaquetteCree$ = new BehaviorSubject<ObjetMaquette | undefined>(undefined);
    public objetMaquetteModifie$ = new BehaviorSubject<ObjetMaquette | undefined>(undefined);
    public objetMaquetteSupprime$ = new BehaviorSubject<string | undefined>(undefined); //String for id ObjetMaquette supprimé
    public structureModifiee$ = new BehaviorSubject<string | undefined>(undefined); //String for id ObjetMaquette modifié
}
